/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Dark_Raven_CallInputs */

const en_keen_dark_raven_call = /** @type {(inputs: Keen_Dark_Raven_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete report`)
};

const de_keen_dark_raven_call = /** @type {(inputs: Keen_Dark_Raven_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht konnte nicht gelöscht werden`)
};

/**
* | output |
* | --- |
* | "Failed to delete report" |
*
* @param {Keen_Dark_Raven_CallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_dark_raven_call = /** @type {((inputs?: Keen_Dark_Raven_CallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Dark_Raven_CallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_dark_raven_call(inputs)
	return de_keen_dark_raven_call(inputs)
});